module.exports = __webpack_public_path__ + "assets/img/logout2.e8943929.svg";